import account from '@/api/accounts'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    account.updateAccountInfo(result => {
      resolve(result.data)
    }, param)
  })
}
